import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency } from "@/lib/utils";
import { RankBadge } from "./GameBadges";

export function LeaderboardView({ leaderboard }) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader className="card-header-flight-deck">
        <CardTitle>{t("dashboard.leaderboard")}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="text-left py-3 px-4 text-xs font-semibold text-slate-500 uppercase">{t("dashboard.rank")}</th>
              <th className="text-left py-3 px-4 text-xs font-semibold text-slate-500 uppercase">{t("dashboard.airline")}</th>
              <th className="text-right py-3 px-4 text-xs font-semibold text-slate-500 uppercase">{t("dashboard.stockPrice")}</th>
              <th className="text-right py-3 px-4 text-xs font-semibold text-slate-500 uppercase">{t("dashboard.cumulativeProfit")}</th>
              <th className="text-center py-3 px-4 text-xs font-semibold text-slate-500 uppercase">{t("dashboard.quality")}</th>
              <th className="text-center py-3 px-4 text-xs font-semibold text-slate-500 uppercase">{t("decisions.fleet")}</th>
            </tr>
          </thead>
          <tbody>
            {leaderboard.map((entry) => (
              <tr key={entry.team_id} className="border-b border-slate-50 hover:bg-slate-50">
                <td className="py-3 px-4">
                  <RankBadge rank={entry.rank} />
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-slate-900">{entry.name}</span>
                    <span className="text-xs text-slate-400 font-mono">{entry.airline_code}</span>
                    {entry.is_ai && (
                      <span className="text-xs bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded">AI</span>
                    )}
                  </div>
                </td>
                <td className="py-3 px-4 text-right font-mono text-slate-700">
                  {formatCurrency(entry.stock_price, 2)}
                </td>
                <td className={`py-3 px-4 text-right font-mono ${entry.cumulative_profit >= 0 ? "text-emerald-600" : "text-rose-600"}`}>
                  {formatCurrency(entry.cumulative_profit)}
                </td>
                <td className="py-3 px-4 text-center">
                  <span className="font-mono">{entry.quality_rating?.toFixed(0)}</span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className="font-mono">{entry.aircraft_count}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </CardContent>
    </Card>
  );
}
